function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#EE415D",
  fillRule: "evenodd",
  d: "M8 1a7 7 0 11-.001 14.001A7 7 0 018 1zm0 9.371a.79.79 0 100 1.58.79.79 0 000-1.58zm.324-5.984h-.648a.339.339 0 00-.339.353l.198 4.742a.338.338 0 00.338.324h.254c.181 0 .33-.143.338-.324l.198-4.742a.339.339 0 00-.339-.353z"
});

function SvgStatusWarninginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgStatusWarninginline;